<template>
	<div class="index">
		<HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
		<div class="head_logo word flex_between">
			<i class="head_logoT"><img src="@/assets/images/logoT.png" alt=""></i>
			<div class="head_search_div flex_between">
				<el-dropdown split-button  @command="handleClick" size="mini" class="btn">
					{{$t(`search.arr`)[searchType]}}
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item,index) in $t(`search.arr`)" :key="index" :command="index">{{item}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<input type="text" :placeholder="$t('header.key')" v-model="serchMsg" @keyup.enter="serchFn">
				<div class="head_search_a flex_center" @click="serchFn">
					<img src="@/assets/images/screen.png" alt="">
				</div>
			</div>
			<div class="head_shopping flex_center" @click="shop">
				<i><img src="@/assets/images/shopping.png" alt=""></i>
				{{$t('header.sopC')}}<span class="head_shopping_num">0</span>{{$t('header.goods')}}
			</div>
		</div>
		<NavView></NavView>
		<!--内容-->
		<div class="content">
			<section class="word section-div">
				<router-link to="/">
					<div class="flex_between section-div-page">
						<span class="section-div-page-url">{{$t('search.home')}} > {{$t('search.search')}}</span>
					</div>
				</router-link>
			</section>
			<section class="word section-content">
				<div class="flex_between section-div-nav">
					<div class="flex_start section-div-nav-left">
						<span class="flex_center" :class="{'class_this' : idx == 0}" @click="tab(0)">{{$t('search.product')}}</span>
						<span class="flex_center" :class="{'class_this' : idx == 1}" @click="tab(1)">{{$t('search.file')}}</span>
						<span class="flex_center" :class="{'class_this' : idx == 2}" @click="tab(2)">{{$t('search.information')}}</span>
					</div>
					<div class="Number">{{$t('search.common')}}<span>{{len}}</span>{{$t('search.result')}}</div>
				</div>
				<div class="flex_start section-div-content" v-if="idx == 0">
					<div class="list" v-for="(item,index) in products" :key="index">
						<div class="flex_center content-img">
							<img :src="item.productImg ?  $img+item.productImg.split(',')[0] : ''" alt />
						</div>
						<div class="product">
							<div class="product-name">{{item.productName}}</div>
							<div class="product-t">{{$t('search.model')}}：{{item.productNum}}</div>
							<div class="product-t">{{$t('search.stock')}}：{{item.stock}}</div>
							<div class="product-price product-t">{{$t('search.Price')}}：<span>${{item.unitPrice / 100}}</span></div>
							<div class="product-detail " @click="det(item.productId)">
								<button>{{$t('search.details')}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="dv" v-if="idx == 1" v-for="(item,index) in file" :key="index">
					<div class="flex_between">
						<div class="flex_start">
							<img :src="item.docUrl" alt="" class="wd_img">
							<div class="wd_title">{{item.title}}</div>
						</div>
						<div class="flex_start">
							<a :href="item.docUrl?$img+item.docUrl:''" style="margin-right: 10px;" download>
								<el-button type="primary" size="mini" @click="download(item.tid)">{{$t('search.member')}}<i class="el-icon-bottom el-icon--right"></i></el-button>
							</a>
							<a :href="item.docUrl?$img+item.docUrl:''" download>
								<el-button size="mini" @click="download(item.tid)">{{$t('search.ordinary')}}<i class="el-icon-bottom el-icon--right"></i></el-button>
							</a>
						</div>
					</div>
					<div class="flex_start wd_txt" v-html="item.content"></div>
					<div class="time flex_start">
						<span>{{$t('search.Views')}}：{{item.browseCount}}</span>
						<span class="l"></span>
						<span>{{$t('search.Download')}}：{{item.dowloadCount?item.dowloadCount:0}}</span>
						<span class="l"></span>
						<span>{{$t('search.time')}}：{{item.createTime}}</span>
					</div>
				</div>
				<div class="page-line" v-for="(item,index) in data" :key="index" @click="detail(item.nid)" v-if="idx == 2">
					<div class="imgbox">
						<img :src="item.imageUrl" alt="图" />
					</div>
					<div class="msg">
						<h3 class="title">{{item.title}}</h3>
						<div>
							<h4 class="font1" v-html="item.content" v-if="!serchContent">{{item.textContent}}</h4>
							<h4 class="font1" v-html="item.textContent" v-else>{{item.content}}</h4>
						</div>
						<i class="line"></i>
						<div class="timer">{{item.createTime}}</div>
					</div>
				</div>
			</section>
		</div>
		<!-- 登录弹窗 -->
		<LoginPop v-if="popShow" @closePop="closePopFn"></LoginPop>
		<!-- 底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import '@/assets/css/header.css';
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗
	export default {
		name: "productSearch",
		data() {
			return {
				num: '1',
				popShow: false,
				products: [], // 产品
				file: [], //文档
				data: [], // 资讯
				searchMsg: '',
				token: '',
				idx: 0,
				serchMsg: '',
				showLoginPop: false,
				searchType: 0,
				serchContent: false,
				len: 0,
				pageNum: 1,
				pageSize: 6,
				totleNum: 50,
			};
		},
		components: {
			// HeaderView,
			NavView,
			HeaderTopView,
			Footer,
			LoginPop
		},
		methods: {
			// 下载
			download(id) {
				let that = this;
				let url = `/open/technology/record/download/count?token=${sessionStorage.getItem('token')}&tid=${id}`;
				this.$get(url).then(res => {
					if (res.code == 0) {
						this.serchFn()
					}

				});
			},
			// 产品详情
			det(id) {
				this.$router.push(`/GoodsDetails?id=${id}`);
			},
			handleClick(e) {
				this.searchType = e
			},
			shop() {
				let token = sessionStorage.getItem('token')
				if (token) { //登录了
					this.$router.push('/shopcar')
					this.showLoginPop = false
				} else {
					this.showLoginPop = true
				}
				this.$emit('showLoginPop', this.showLoginPop)
			},
			tab(e) {
				this.idx = e
				if (e == 0) {
					this.len = this.products.length
				} else if (e == 1) {
					this.len = this.file.length
				} else {
					this.len = this.data.length
				}
			},
			parentFn(payload) {
				console.log("登录" + payload);
			},
			showLoginPopFn(i) {
				this.popShow = i;
			},
			closePopFn(i) {
				this.popShow = !i;
			},
			/*获取搜索产品*/
			serchFn() {
				if (this.serchMsg == '') {
					this.$message({
						message: this.$t('Tips.search'),
						type: 'warning'
					});
					return false
				}
				this.products = []
				this.file = []
				let that = this
				let url = "/open/all/search"
				this.token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '1'
				let data = {
					pageNum: 1,
					pageSize: 9,
					searchType: this.searchType,
					token: this.token,
					keyWord: this.serchMsg
				}
				this.$get(url, data).then(res => {
					if (res.code == 0) {
						if (res.data.productResult !== null) {
							that.products = res.data.productResult.data
							that.len = res.data.productResult.data.length
						}
						if (res.data.technologyResult !== null) {
							that.file = res.data.technologyResult.data
							that.len = res.data.productResult.data.length
						}
						if (res.data.informationResult !== null) {
							that.data = res.data.informationResult.data
							that.len = res.data.productResult.data.length
						}
					}
				})

			}
		},
		mounted() {
			this.searchType = this.$route.query.id
		}
	}
</script>

<style scoped>
	.btn{
		  border:0;
		  border-left: #000000 solid 1px !important;
		  border-right: #000000 solid 1px !important;
		  border-radius: none;
		  height: 30px;
		  width: 125px;
		  .el-button-group>.el-button:not(:last-child) {
			margin-right: -1px;
			width: calc(100% - 30px);
		}
	}
	.content {
		padding: 64px 0 48px 0;
	}

	.page {
		margin-bottom: 48px;
	}

	.page-line {
		display: flex;
		margin-top: 70px;
	}

	.page-line:first-child {
		margin-top: 0;
	}

	.imgbox {
		width: 382px;
		height: 262px;
		margin-right: 54px;
	}

	.msg {
		width: 766px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.title {
		color: #1a1a1a;
		font-size: 22px;
		text-align: left;
	}

	.font1 {
		font-size: 16px;
		color: #4a4a4a;
		margin: 27px 0 36px 0;
		text-align: left;
	}

	.font1>p>img {
		width: 30px !important;
	}

	.line {
		display: block;
		width: 144px;
		height: 2px;
		background: #000000;
	}

	.timer {
		font-size: 20px;
		color: #333;
		text-align: left;
		margin-top: 23px;
	}

	.l {
		width: 1px;
		height: 12px;
		background: #ccc;
		display: inline-block;
		margin: 0 10px;
	}

	.wd_txt {
		padding: 20px 0;
		font-size: 16px;
		color: #666666;
		border-bottom: dashed 1px #ccc;
	}

	.time {
		padding: 20px 0;
		font-size: 14px;
		color: #666;
		align-items: center;
	}

	.wd_title {
		font-size: 20px;
		color: #107AD0;
		margin-left: 17px;

	}

	.dv {
		margin-top: 20px;
		width: calc(100% - 60px);
		background: white;
		padding: 30px;
	}

	.wd_img {
		width: 30px;
		height: 30px;
	}

	.head_search_div {
		border-left: none !important;
	}

	.section-div-content .list {
		height: 203px;
		width: 385px;
		margin-right: 22px;
		box-sizing: border-box;
		margin-bottom: 22px;
	}

	.section-div-content .list:nth-child(3n) {
		margin-right: 0;
	}

	.Number {
		font-size: 16px;
		color: #666666;
	}

	.Number>span {
		color: #117CD1;

	}


	.section-div .section-div-page {
		margin-top: 14px;
	}

	.section-div .section-div-page-url {
		margin-top: 14px;
		margin-left: 1px;
		height: 14px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: rgba(74, 74, 74, 1);
		line-height: 15px;
	}

	.section-div-nav {
		margin-top: 16px;
		border-bottom: 1px solid #E6E3E6;

	}

	.section-div-nav-left {
		margin-top: 16px;
		margin-left: 24px;
	}

	.section-div-nav-left span {
		margin-right: 42px;
		font-size: 18px;
		font-family: PingFang SC;
		padding-bottom: 10px;
		color: #626262;
	}

	.section-div-content {
		width: calc(100%);
		height: 100%;
		margin-top: 24px;
		flex-wrap: wrap;
	}

	.section-content {
		margin-bottom: 38px;
	}

	.section-content .section-div-content {
		flex-wrap: wrap;
	}

	.section-div-content>div {
		height: 140px;
		display: inline-flex;
		position: relative;
		background: #f8f8fa;
		transition: all 0.5s ease;
		float: left;
	}

	section-content .section-div-content .product {
		margin: 0px auto;
	}

	.section-content .section-div-content .product .product-t {
		color: #1A1A1A;
		font-size: 13px;
		margin: 10px 0;
		display: flex;
		font-weight: bold;
	}

	.section-div-content .content-img {
		width: 40%;
	}

	.section-div-content .content-img>img {
		width: 104px;
		height: 104px;
	}

	.product .product-name {
		font-size: 14px !important;
		color: #089ecc;
		margin: 18px 0;
		display: flex;
	}

	.product .product-price>span {
		color: #D03B3B;
		font-weight: bold;
		font-size: 16px;
	}

	.product .product-detail {
		display: flex;
	}

	.product .product-detail>button {
		color: white;
		width: 76px;
		height: 26px;
		text-align: center;
		line-height: 26px;
		background: -webkit-linear-gradient(#3F9FEA, #0A77CE);
		background: -o-linear-gradient(#3F9FEA, #0A77CE);
		background: -moz-linear-gradient(#3F9FEA, #0A77CE);
		background: linear-gradient(#3F9FEA, #0A77CE);
	}

	.section-div-nav-left .class_this {
		color: #0D79CF;
		border-bottom: 2px solid #0D79CF;
		font-weight: bold;
	}
	.content {
		padding: 64px 0 48px 0;
	}

	.page {
		margin-bottom: 48px;
	}

	.page-line {
		display: flex;
		margin-top: 70px;
		/*justify-content: space-between;*/
	}

	.page-line:first-child {
		margin-top: 0;
	}

	.imgbox {
		width: 382px;
		height: 262px;
		margin-right: 54px;
	}

	.msg {
		width: 766px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.title {
		color: #1a1a1a;
		font-size: 22px;
		text-align: left;
	}

	.font1 {
		font-size: 16px;
		color: #4a4a4a;
		margin: 27px 0 36px 0;
		text-align: left;
	}

	.font1>p>img {
		width: 30px !important;
	}

	.line {
		display: block;
		width: 144px;
		height: 2px;
		background: #000000;
	}

	.timer {
		font-size: 20px;
		color: #333;
		text-align: left;
		margin-top: 23px;
	}

	.l {
		width: 1px;
		height: 12px;
		background: #ccc;
		display: inline-block;
		margin: 0 10px;
	}

	.wd_txt {
		padding: 20px 0;
		font-size: 16px;
		color: #666666;
		border-bottom: dashed 1px #ccc;
	}

	.time {
		padding: 20px 0;
		font-size: 14px;
		color: #666;
		align-items: center;
	}

	.wd_title {
		font-size: 20px;
		color: #107AD0;
		margin-left: 17px;

	}

	.dv {
		margin-top: 20px;
		width: calc(100% - 60px);
		background: white;
		padding: 30px;
	}

	.wd_img {
		width: 30px;
		height: 30px;
	}

	.head_search_div {
		border-left: none !important;
	}

	.section-div-content .list {
		height: 203px;
		width: 385px;
		margin-right: 22px;
		box-sizing: border-box;
		margin-bottom: 22px;
	}

	.section-div-content .list:nth-child(3n) {
		margin-right: 0;
	}

	.Number {
		font-size: 16px;
		color: #666666;
	}

	.Number>span {
		color: #117CD1;

	}


	.section-div .section-div-page {
		margin-top: 14px;
	}

	.section-div .section-div-page-url {
		margin-top: 14px;
		margin-left: 1px;
		height: 14px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: rgba(74, 74, 74, 1);
		line-height: 15px;
	}

	.section-div-nav {
		margin-top: 16px;
		border-bottom: 1px solid #E6E3E6;

	}

	.section-div-nav-left {
		margin-top: 16px;
		margin-left: 24px;
	}

	.section-div-nav-left span {
		margin-right: 42px;
		font-size: 18px;
		font-family: PingFang SC;
		padding-bottom: 10px;
		color: #626262;
	}

	.section-div-content {
		width: calc(100%);
		height: 100%;
		margin-top: 24px;
		flex-wrap: wrap;
	}

	.section-content {
		margin-bottom: 38px;
	}

	.section-content .section-div-content {
		flex-wrap: wrap;
	}

	.section-div-content>div {
		height: 140px;
		display: inline-flex;
		position: relative;
		background: #f8f8fa;
		transition: all 0.5s ease;
		float: left;
	}

	section-content .section-div-content .product {
		margin: 0px auto;
	}

	.section-content .section-div-content .product .product-t {
		color: #1A1A1A;
		font-size: 13px;
		margin: 10px 0;
		display: flex;
		font-weight: bold;
	}

	.section-div-content .content-img {
		width: 40%;
	}

	.section-div-content .content-img>img {
		width: 104px;
		height: 104px;
	}

	.product .product-name {
		font-size: 14px !important;
		color: #089ecc;
		margin: 18px 0;
		display: flex;
	}

	.product .product-price>span {
		color: #D03B3B;
		font-weight: bold;
		font-size: 16px;
	}

	.product .product-detail {
		display: flex;
	}

	.product .product-detail>button {
		color: white;
		width: 76px;
		height: 26px;
		text-align: center;
		line-height: 26px;
		background: -webkit-linear-gradient(#3F9FEA, #0A77CE);
		background: -o-linear-gradient(#3F9FEA, #0A77CE);
		background: -moz-linear-gradient(#3F9FEA, #0A77CE);
		background: linear-gradient(#3F9FEA, #0A77CE);
	}

	.section-div-nav-left .class_this {
		color: #0D79CF;
		border-bottom: 2px solid #0D79CF;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/ProductSearch.vue